"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const theme_provider_1 = require("../theme-provider");
const Close = require("../../../volkswagen-onehub/icons-core/dist/Close");

const character_counter_1 = require("./character-counter");
var TextInputAppearance;
(function (TextInputAppearance) {
    TextInputAppearance[TextInputAppearance["Default"] = 0] = "Default";
    TextInputAppearance[TextInputAppearance["Disabled"] = 1] = "Disabled";
    TextInputAppearance[TextInputAppearance["Error"] = 2] = "Error";
    TextInputAppearance[TextInputAppearance["Success"] = 3] = "Success";
    TextInputAppearance[TextInputAppearance["ReadOnly"] = 4] = "ReadOnly";
    TextInputAppearance[TextInputAppearance["Search"] = 5] = "Search";
})(TextInputAppearance = exports.TextInputAppearance || (exports.TextInputAppearance = {}));
// @todo get from theme
const borderSize = '1px';
const StyledLabelText = theme_provider_1.styled.p.withConfig({ displayName: "StyledLabelText", componentId: "sc-mm7j4t" }) `
	font-size: ${({ theme, isFloating }) => isFloating
    ? theme.textAppearances.copy0200.fontSize
    : theme.textAppearances.copy0100.fontSize};
	margin: 0;
	padding: 0;
	position: absolute;
	top: 0;
	${({ theme, isFloating, hasIcon, hasValue }) => isFloating
    ? theme_provider_1.css `
					padding: 0 ${hasIcon && !hasValue ? theme.size.static400 : 0};
					transition: all ease-in-out 0.25s;
					transform: translateY(${theme.size.static250})
						// Move it down by the padding on the 'StyledLabel'
						translateY(${theme.size.static100})
						// Move it down by the margin on the 'StyledInput'
						translateY(${theme.size.static150})
						// Move it down by the padding on the 'StyledInput'
						translateY(${props => parseInt(props.theme.size.static300) / 2}px)
						// Move it down by half the size of the 'StyledInput'
						translateY(-50%);
					// Move it up by half of its own size
			  `
    : undefined}
`;
const StyledInput = theme_provider_1.styled.input.withConfig({ displayName: "StyledInput", componentId: "sc-1w0vcmp" }) `
	min-height: ${props => props.theme.size.static300};
	width: 100%;
	padding: ${props => `${props.theme.size.static150} 0`};
	border: 0;
	border-bottom: ${({ appearance }) => appearance !== TextInputAppearance.ReadOnly && `${borderSize} solid`};
	border-color: ${({ theme, appearance }) => appearance === TextInputAppearance.Error
    ? theme.interaction.recipe360.default
    : appearance === TextInputAppearance.Success
        ? theme.interaction.recipe350.default
        : theme.interaction.recipe150.default};
	border-radius: 0;
	background: transparent;
	cursor: ${props => props.appearance === TextInputAppearance.Disabled ? 'not-allowed' : ''};
	color: ${({ theme, appearance }) => appearance === TextInputAppearance.ReadOnly
    ? theme.interaction.recipe100.default
    : appearance === TextInputAppearance.Disabled
        ? theme.interaction.recipe500.disabled
        : theme.interaction.recipe500.default};
	outline: 0;
	font-size: ${props => props.theme.textAppearances.copy0200.fontSize};

	font-family: inherit;
	margin-top: ${props => props.theme.size.static100};

	&:focus {
		border-color: ${({ theme, appearance }) => appearance !== TextInputAppearance.Error &&
    appearance !== TextInputAppearance.Success
    ? theme.interaction.recipe150.checked
    : undefined};

		~ ${StyledLabelText} {
			padding: 0;
			transform: translateY(0);
			font-size: ${props => props.theme.textAppearances.copy100.fontSize};
		}
	}

	${props => props.hasValue &&
    theme_provider_1.css `
			& ~ ${StyledLabelText} {
				transform: translateY(0);
				font-size: ${props.theme.textAppearances.copy100.fontSize};
			}
		`}

	&::-ms-clear {
		display: none;
	}
`;
const StyledIcon = theme_provider_1.styled.div.withConfig({ displayName: "StyledIcon", componentId: "sc-1f3h855" }) `
	display: flex;
	position: absolute;
	top: 0;
	opacity: ${props => (props.hasValue ? 0 : 1)};
	transition: all ease-in-out 0.25s;

	${({ theme }) => theme_provider_1.css `
		transform: translateY(${theme.size.static250})
			// Move it down by the padding on the 'StyledLabel'
			translateY(${theme.size.static100})
			// Move it down by the margin on the 'StyledInput'
			translateY(${theme.size.static150})
			// Move it down by the padding on the 'StyledInput'
			translateY(${props => parseInt(props.theme.size.static300) / 2}px)
			// Move it down by half the size of the 'StyledInput'
			translateY(-50%);
		// Move it up by half of its own size
	`}
`;
const StyledLabel = theme_provider_1.styled.label.withConfig({ displayName: "StyledLabel", componentId: "sc-f333zj" }) `
	display: block;
	width: 100%;
	position: relative;
	padding-top: ${props => props.theme.size.static250};
	color: ${({ theme, appearance }) => appearance === TextInputAppearance.ReadOnly
    ? theme.interaction.recipe100.default
    : appearance === TextInputAppearance.Disabled
        ? theme.interaction.recipe500.disabled
        : appearance === TextInputAppearance.Search
            ? theme.interaction.recipe400.default
            : theme.interaction.recipe450.default};

	&:focus-within {
		&::after {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			transform: translateY(-50%);
			width: 100%;
			height: calc(100% + 4px);
			border-width: 2px 0;
			border-color: ${props => props.theme.focusColor};
			border-style: solid;
			pointer-events: none;
		}
		& ${StyledIcon} {
			opacity: 0;
		}
	}
`;
const StyledAdditionalInfo = theme_provider_1.styled.div.withConfig({ displayName: "StyledAdditionalInfo", componentId: "sc-171qqul" }) `
	display: flex;
	flex-direction: row;
	justify-content: ${props => props.errorShouldBeVisible ? 'space-between' : 'flex-end'};
	color: ${({ theme, appearance }) => appearance === TextInputAppearance.Error
    ? theme.interaction.recipe360.default
    : appearance === TextInputAppearance.Disabled
        ? theme.interaction.recipe150.disabled
        : theme.interaction.recipe150.default};
`;
const StyledErrorText = theme_provider_1.styled.p.withConfig({ displayName: "StyledErrorText", componentId: "sc-1r1saal" }) `
	display: block;
	color: ${props => props.theme.interaction.recipe360.default};
	font-size: ${props => props.theme.textAppearances.copy0100.fontSize};
	margin: 0;
`;
const StyledClearButton = theme_provider_1.styled.button.withConfig({ displayName: "StyledClearButton", componentId: "sc-9oxm7r" }) `
	position: relative;
	background: transparent;
	padding: 0;
	border: none;
	line-height: 0;
	cursor: pointer;
	border-bottom: 1px solid transparent;
	outline: 0;
	pointer-events: initial;
	:hover {
		::before {
			content: '';
			border-radius: 50%;
			width: 100%;
			height: 100%;
			position: absolute;
			background-color: ${props => props.theme.hoverIndicatorColor.outlinedElement.default};
			box-shadow: 0 0 0
				${props => parseInt(props.theme.size.static350, 10) / 2}px
				${props => props.theme.hoverIndicatorColor.outlinedElement.default};
		}
	}
	:focus {
		::after {
			content: '';
			position: absolute;
			left: 0;
			top: -4px;
			width: 100%;
			height: calc(100% + 4px);
			border-width: 2px 0;
			border-color: ${props => props.theme.focusColor};
			border-style: solid;
			pointer-events: none;
		}
	}
`;
const StyledClearButtonWrapper = theme_provider_1.styled.div.withConfig({ displayName: "StyledClearButtonWrapper", componentId: "sc-ellmk9" }) `
	position: absolute;
	right: 0;
	left: 0;
	top: 0;
	pointer-events: none;
	display: flex;
	flex-direction: row-reverse;
	${({ theme }) => theme_provider_1.css `
		transform: translateY(${theme.size.static250})
			// Move it down by the padding on the 'StyledLabel'
			translateY(${theme.size.static100})
			// Move it down by the margin on the 'StyledInput'
			translateY(${theme.size.static150})
			// Move it down by the padding on the 'StyledInput'
			translateY(${props => parseInt(props.theme.size.static300) / 2}px)
			// Move it down by half the size of the 'StyledInput'
			translateY(-50%);
		// Move it up by half of its own size
	`}
`;
/* eslint-disable-next-line react/display-name */
class TextInputInner extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasValue: false };
        this.validateInputField = this.validateInputField.bind(this);
    }
    validateInputField(event) {
        this.setState({ hasValue: Boolean(event.currentTarget.value) });
    }
    componentDidMount() {
        this.setState({ hasValue: Boolean(this.props.value) });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.value !== prevProps.value &&
            prevState.hasValue !== Boolean(this.props.value)) {
            this.setState({ hasValue: Boolean(this.props.value) });
        }
    }
    render() {
        const { additionalFeedback, appearance, autoFocus, clearIconLabel = '', defaultValue, errorText, hasClearButton, icon, innerRef, isClearButtonVisible, isFloating, label = '', maxLength, name, onBlur, onChange, onKeyDown, onClear, onFocus, placeholder, required = false, type, value, autoComplete } = this.props;
        const { hasValue } = this.state;
        const errorShouldBeVisible = Boolean(appearance === TextInputAppearance.Error && errorText);
        return (React.createElement(StyledLabel, { appearance: appearance },
            icon && (React.createElement(StyledIcon, { maxLength: maxLength, hasValue: hasValue }, icon)),
            React.createElement(StyledInput, { appearance: appearance, autoFocus: autoFocus, defaultValue: defaultValue, disabled: appearance === TextInputAppearance.Disabled, icon: icon, maxLength: maxLength, name: name, onBlur: event => {
                    this.validateInputField(event);
                    if (onBlur) {
                        onBlur(event);
                    }
                }, onChange: onChange, onFocus: onFocus, onKeyDown: onKeyDown, placeholder: placeholder, readOnly: appearance === TextInputAppearance.ReadOnly, ref: innerRef, required: required, type: type, value: value, autoComplete: autoComplete, hasValue: hasValue }),
            hasClearButton && isClearButtonVisible && (React.createElement(StyledClearButtonWrapper, { maxLength: maxLength },
                React.createElement(StyledClearButton, { "aria-label": clearIconLabel, title: clearIconLabel, onClick: onClear, type: "button" },
                    React.createElement(Close, { variant: "default" })))),
            React.createElement(StyledLabelText, { hasIcon: Boolean(icon), isFloating: isFloating, hasValue: hasValue },
                label,
                required && '*'),
            (errorShouldBeVisible || maxLength) && (React.createElement(StyledAdditionalInfo, { errorShouldBeVisible: errorShouldBeVisible, appearance: appearance },
                errorShouldBeVisible && (React.createElement(StyledErrorText, { "aria-live": "assertive", "aria-relevant": "all" }, errorText)),
                maxLength && (React.createElement(character_counter_1.CharacterCounter, { value: value, maxLength: maxLength })))),
            additionalFeedback));
    }
}
exports.TextInput = React.forwardRef((props, ref) => React.createElement(TextInputInner, Object.assign({}, props, { innerRef: ref })));
